export const getGtmInstructionsStyles = () => ({
  container: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#323130',
    marginBottom: '12px',
  },
  steps: {
    fontSize: '14px',
    marginBottom: '12px',
  },
  instructionContainer: {
    marginLeft: '29px',
    marginTop: '16px',
    paddingBottom: '16px',
  },
  instructionBody: {
    marginLeft: '50px',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '23px',
  },
  instructionTitle: {
    fontWeight: 400,
    fontSize: '15px',
    lineHeight: '20px',
  },
  instructionInfo: {
    background: '#EFF6FC',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '36px',
    height: '36px',
    maxWidth: '696px',
  },
  instructionInfoIcon: {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  instructionImage: {
    marginRight: '79px',
    marginBottom: '20px',
    maxWidth: 1000,
  },
  downloadButton: {
    marginTop: '12px',
  },
  downloadButtonIcon: {
    color: '#0078D4',
  },
  eventParamTable: {
    borderTop: '1px solid #979797',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: 800,
    marginTop: 7,

    '& th': {
      borderBottom: '1px solid #979797',
      padding: 12,
      textAlign: 'left',
    },

    '& tr': {
      display: 'table-row',
      verticalAlign: 'inherit',
      borderColor: 'inherit',

      '& td:first-child': {
        borderLeft: 0,
      },

      '& td:last-child': {
        borderRight: 0,
      },
    },

    '& td': {
      border: '1px solid #F3F2F1',
      padding: 12,
    },
  },
});
